var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dashboard-container"},[_c('loading',{attrs:{"active":_vm.loading,"opacity":0.8,"loader":"dots","color":"#315564","can-cancel":false,"is-full-page":true}}),_vm._l((_vm.users),function(user){return [_c('UserCard',{attrs:{"user":user}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }